import { render, staticRenderFns } from "./VformProjectList.vue?vue&type=template&id=158ffb92&scoped=true&"
import script from "./VformProjectList.vue?vue&type=script&lang=js&"
export * from "./VformProjectList.vue?vue&type=script&lang=js&"
import style0 from "./VformProjectList.vue?vue&type=style&index=0&id=158ffb92&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158ffb92",
  null
  
)

export default component.exports